import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as actions from 'react/api/actions/stopDetailsPopup';
import ButtonWithIcon from 'react/components/ButtonWithIcon';
import { 
  arrivalAccuracyIcon,
  arrivalAccuracyIconActive
} from 'react/utils/stopDetailsPopupBase64Icons.js';

class ArrivalAccuracyButton extends Component {
  
  toggleArrivalAccuracy = (e) => {
    const {
      routeId, stopId, enableArrivalAccuracyAction, 
      disableArrivalAccuracyAction, arrivalAccuracyIsEnabled, 
      addArrivalAccuracyToMapAction, removeArrivalAccuracyFromMapAction
    } = this.props;
    e.stopPropagation();
    removeArrivalAccuracyFromMapAction(routeId, stopId);
    if (arrivalAccuracyIsEnabled) {
      disableArrivalAccuracyAction(routeId, stopId);
    } else {
      enableArrivalAccuracyAction(routeId, stopId);
      addArrivalAccuracyToMapAction(routeId, stopId);
    }
  }

  componentDidMount = ()  => {
    const { 
      routeId, stopId, arrivalAccuracyIsEnabled,
      addArrivalAccuracyToMapAction
    } = this.props;
    if (arrivalAccuracyIsEnabled) {
      addArrivalAccuracyToMapAction(routeId, stopId);
    }
  }

  render() {
    const { arrivalAccuracyIsEnabled, ...others } = this.props;
    return (
      <ButtonWithIcon
      label={Monet.I18n.getResourcesByKey('routeDetails.stopDetailsPopup.zones.arrivalAccuracy')}
      isActive={arrivalAccuracyIsEnabled} 
      iconUrl={arrivalAccuracyIcon}
      activeIconUrl={arrivalAccuracyIconActive}
      onClick={this.toggleArrivalAccuracy}
      {...others}/>
    );
  }
}

ArrivalAccuracyButton.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  arrivalAccuracyIsEnabled: PropTypes.bool.isRequired,
  enableArrivalAccuracyAction: PropTypes.func.isRequired,
  disableArrivalAccuracyAction: PropTypes.func.isRequired,
  addArrivalAccuracyToMapAction: PropTypes.func.isRequired,
  removeArrivalAccuracyFromMapAction: PropTypes.func.isRequired
}

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({ 
  arrivalAccuracyIsEnabled: stopDetailsPopup.getIn(['actionButtons', String(routeId), String(stopId), 'arrivalAccuracyIsEnabled'], false)
});

const mapDispatchToProps = (dispatch) => ({
  enableArrivalAccuracyAction: bindActionCreators(actions.enableArrivalAccuracy, dispatch),
  disableArrivalAccuracyAction: bindActionCreators(actions.disableArrivalAccuracy, dispatch),
  addArrivalAccuracyToMapAction: bindActionCreators(actions.addArrivalAccuracyToMap, dispatch),
  removeArrivalAccuracyFromMapAction: bindActionCreators(actions.removeArrivalAccuracyFromMap, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ArrivalAccuracyButton);

